module.exports = __webpack_public_path__ + "img/882731c.jpg";